<ng-container *ngIf="phxHeader">
  <ng-container *ngTemplateOutlet="phxHeader">
  </ng-container>
</ng-container>
<ng-container *ngIf="phxBody">
  <ng-container *ngTemplateOutlet="phxBody">
  </ng-container>
</ng-container>